// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Y0Rc","left":"styles_left__3kj1u","right":"styles_right__1atdh","alert":"styles_alert__3EabT"};